/**
 * Resetting a second factor (TM-9636 / #1627).
 *
 * A lost phone may not hold a practice's billing up, and Therame is never the
 * place that resets a factor (#1598). Three ways out, all inside the practice:
 * a Standort's ADMIN for a colleague, the lock notice on one's own account, and
 * fresh recovery codes against a fresh factor.
 */
/**
 * How far a reset reaches.
 *
 * ⚠ **One word for both edges.** This enum stands in the HTTP contract, on the
 * `IdentityProvider` port, in the log column and — character for character — as
 * `SecondFactorResetScope` in the Keycloak SPI. A second member in one place
 * that is missing in the other would let a request run silently into nothing.
 */
export var SecondFactorResetScope;
(function (SecondFactorResetScope) {
    /**
     * Every second factor falls: authenticator app, passkey and the recovery
     * codes. This is the ADMIN's reset and the lock notice on one's own account.
     *
     * Keycloak sets **no** required action afterwards. Whoever logs in next sees
     * no QR image; the enrolment belongs in the Versand release's step-up, and it
     * is only needed there.
     */
    SecondFactorResetScope["ALL"] = "ALL";
    /**
     * Only the recovery codes, against a fresh set. The device stays: whoever
     * wants new codes still has their app.
     *
     * This scope sets the required action `CONFIGURE_RECOVERY_AUTHN_CODES`.
     * Keycloak shows a generated set exactly once, on that action's page; without
     * the action nobody would ever get to see the codes.
     */
    SecondFactorResetScope["RECOVERY_CODES"] = "RECOVERY_CODES";
})(SecondFactorResetScope || (SecondFactorResetScope = {}));
/**
 * A reset's receipt.
 *
 * ⚠ **No code in the body.** Keycloak shows the recovery codes on its own page,
 * exactly once, at the next login. If even one came back here, it would stand
 * in the browser's network log and in every cache in front of it.
 */
export class SecondFactorResetDto {
    /** When it was reset, ISO 8601. */
    resetAt;
    scope;
}
//# sourceMappingURL=second-factor-reset.js.map